import fetchApi from "../fetchApi";
import { DEFAULT_LIMIT } from "../../contstants";
// import SecureStorage from "../../utils/secureStorage";
import { TOKEN_KEY } from "../../config/variables";
export const GetOrders = async (
  limit = DEFAULT_LIMIT,
  offset = 0,
  name = "",
  company_id = "",
  office_id = "",
  status,
  dateFrom = "",
  dateTo = "",
  id = ""
) => {
  // const token = await SecureStorage.getItem(TOKEN_KEY);
  const options = {
    method: "GET",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    redirect: "follow",
  };

  return await fetchApi(
    `card-issuing/order?limit=${limit}&offset=${offset}&name=${name}&company_ids=${company_id}&office_id=${office_id}&status=${status}&created_on_gte=${dateFrom}&created_on_lte=${dateTo}&ids=${id}`,
    options
  );
};
